import { PropsWithChildren } from "react";
import { Pressable, StyleSheet } from "react-native";

import { BMPrimitives } from "@traveloka/district-bloom";

import BMView from "../../../../components/View/BMView";

type MenuListHeaderWrapperProps = PropsWithChildren<{
  isAccordion?: boolean;
  onClick?: () => void;
}>;

export function MenuListHeaderWrapper({
  isAccordion,
  onClick,
  children,
}: MenuListHeaderWrapperProps) {
  const container = (
    <BMView
      row
      flex
      spacing="md"
      align="center"
      justify="between"
      style={[
        styles.container,
        !isAccordion && styles.containerWithOutAccordion,
      ]}
    >
      {children}
    </BMView>
  );
  return isAccordion ? (
    <Pressable onPress={onClick}>{container}</Pressable>
  ) : (
    container
  );
}
const styles = StyleSheet.create({
  container: {
    paddingVertical: BMPrimitives.BMSize.sm,
    paddingHorizontal: BMPrimitives.BMSize.md,
  },
  containerWithOutAccordion: {
    paddingVertical: BMPrimitives.BMSize.md,
  },
});
